import React from "react";

import { sqlDateToHumanDate, getPropInSubLevelRole, safeValue, getPropInLevelRole } from "../../utils/globalFunctions";

import LabelContentInline from "../../components/general/LabelContentInline";

const SUDataUserData = ({ stateData }) => {
    return (
        <React.Fragment>
            <LabelContentInline
                stateColLabel={4}
                stateLabel='Nama'
                stateContent={stateData.user_name}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Email'
                stateContent={safeValue(stateData.user_email, '-')}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Gender'
                stateContent={stateData.user_gender === '1' ? 'Pria' : 'Wanita'}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Jabatan'
                stateContent={getPropInLevelRole(stateData.user_level, 'caption', '-')}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Sub Jabatan'
                stateContent={getPropInSubLevelRole(stateData.user_sub_level, 'caption', '-')}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Status'
                stateContent={stateData.user_is_active === '1' ? 'Aktif' : 'Non Aktif'}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Tanggal Input'
                stateContent={sqlDateToHumanDate({
                    stateDate: stateData.date_created,
                    stateWithTime: true,
                    stateLang: 'id',
                    stateIsShort: false,
                    stateDay: false,
                    stateDefaultValue: ' - ',
                    stateDateType: 'day'
                })}
                stateDivider={false}
            />
        </React.Fragment>
    )
}

export default SUDataUserData;